import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import PayoutHistoryComponent from "./component";
import Sidebar from "../../../component/Navigation/Sidebar/Sidebar";
import moment from 'moment';

const PayoutHistoryContainer = (props) => {
  const navigate = useNavigate();
  const [uploads, setUploads] = useState([]);
  const [filteredUploads, setFilteredUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    filename: ""
  });
  const [successPopup, setSuccessPopup] = useState({
    show: false,
    message: ""
  });

  // Fetch payout history
  useEffect(() => {
    fetchPayoutHistory();
  }, []);

  const fetchPayoutHistory = () => {
    setLoading(true);
    props.getDataFromAPI(
      '/partner/api/v1/payout-df',
      "GET",
      undefined,
      (response) => {
        console.log("API Response:", response);
        // Check if response has data property or is directly the array
        const uploadsData = response?.uploads || response || response || [];
        
        // Ensure uploadsData is an array
        if (Array.isArray(uploadsData)) {
          setUploads(uploadsData);
          setFilteredUploads(uploadsData);
        } else {
          console.error("Unexpected response format:", response);
          setUploads([]);
          setFilteredUploads([]);
        }
        setLoading(false);
      },
      (error) => {
        console.error("Fetch error:", error);
        setError("Failed to fetch payout history");
        setLoading(false);
      }
    );
  };

  console.log("Uploads:", uploads);

  // Format date for display (1st Dec 2025)
  const formatDisplayDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = moment(dateString);
    return date.format(`DD MMM YYYY`);
  };

  // Handle search with proper whitespace trimming
  useEffect(() => {
    filterData();
  }, [searchTerm, startDate, endDate, uploads]);

  const filterData = () => {
    let filtered = [...uploads];

    // Search by ID or filename - with whitespace trimming
    if (searchTerm) {
      // Trim the search term to remove leading/trailing spaces
      const trimmedSearchTerm = searchTerm.trim();
      
      if (trimmedSearchTerm) {
        filtered = filtered.filter(item => {
          // Convert ID to string and trim any whitespace
          const itemId = item.id?.toString().trim() || '';
          const itemFilename = item.filename?.trim() || '';
          
          // Check if trimmed ID or filename includes the trimmed search term
          return itemId.includes(trimmedSearchTerm) ||
                 itemFilename.toLowerCase().includes(trimmedSearchTerm.toLowerCase());
        });
      }
    }

    // Filter by date range
    if (startDate && endDate) {
      filtered = filtered.filter(item => {
        const itemDate = moment(item.payoutDate);
        return itemDate.isBetween(moment(startDate), moment(endDate), 'day', '[]');
      });
    } else if (startDate) {
      filtered = filtered.filter(item => 
        moment(item.payoutDate).isSameOrAfter(moment(startDate), 'day')
      );
    } else if (endDate) {
      filtered = filtered.filter(item => 
        moment(item.payoutDate).isSameOrBefore(moment(endDate), 'day')
      );
    }

    setFilteredUploads(filtered);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const clearDateFilter = () => {
    setStartDate("");
    setEndDate("");
    setShowDateFilter(false);
  };

  const handleUploadNew = () => {
    navigate("/home/dfpayout/dfpayoutcreate");
  };

  // Delete handlers
  const handleDeleteClick = (id, filename) => {
    setDeleteModal({
      show: true,
      id,
      filename
    });
  };

  const handleDeleteConfirm = () => {
    const { id } = deleteModal;
    
    props.getDataFromAPI(
      `/partner/api/v1/payout-df/${id}`,
      "DELETE",
      null,
      (response) => {
        setDeleteModal({ show: false, id: null, filename: "" });
        setSuccessPopup({
          show: true,
          message: "Payout record deleted successfully!"
        });
        // Refresh the list
        fetchPayoutHistory();
      },
      (error) => {
        console.error("Delete error:", error);
        setError("Failed to delete payout record");
        setDeleteModal({ show: false, id: null, filename: "" });
      }
    );
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ show: false, id: null, filename: "" });
  };

  const handleSuccessPopupClose = () => {
    setSuccessPopup({ show: false, message: "" });
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ flex: 1 }}>
        <PayoutHistoryComponent
          uploads={filteredUploads}
          loading={loading}
          error={error}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          showDateFilter={showDateFilter}
          onToggleDateFilter={() => setShowDateFilter(!showDateFilter)}
          onClearDateFilter={clearDateFilter}
          onUploadNew={handleUploadNew}
          formatDisplayDate={formatDisplayDate}
          onDeleteClick={handleDeleteClick}
          deleteModal={deleteModal}
          onDeleteConfirm={handleDeleteConfirm}
          onDeleteCancel={handleDeleteCancel}
          successPopup={successPopup}
          onSuccessPopupClose={handleSuccessPopupClose}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { state };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(PayoutHistoryContainer);